import { IVoteStats } from '../interface/IVoteStats'

export class VoteStats implements IVoteStats {
  id?: number
  votesNegative: number
  votesPositive: number
  votesScore: number
  superLikes: number

  public constructor() {
    this.votesNegative = 0
    this.votesPositive = 0
    this.votesScore = 0
    this.superLikes = 0
  }
}
